import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const HEALTHCARE_PROVIDERS_QUERY_KEY = "HEALTHCARE_PROVIDERS_QUERY_KEY";

export const useCareProvidersQuery = (patientUserId) => {
  return useQuery({
    queryKey: [HEALTHCARE_PROVIDERS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listCareProviders.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useCareProviderQuery = (patientUserId, id) => {
  return useQuery({
    queryKey: [HEALTHCARE_PROVIDERS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: listCareProviders.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    select: (healthCareProviders) => {
      const helthCareProvider = healthCareProviders.filter(
        (provider) => provider.id === id
      )[0];
      const pPhone = helthCareProvider?.providerPhone?.split("-") ?? null;
      return {
        ...helthCareProvider,
        providerPhone: pPhone ? pPhone[1] : "",
        dialCode: pPhone ? pPhone[0] : "",
      };
    },

    enabled: !!patientUserId,
  });
};

const listCareProviders = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "careprovidersapi",
    path: "/healthcare-providers/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
